import styled, { css } from "styled-components/macro";
import Colors from "./colorswatches";
import { queryStringParams } from "./utilities";

const Link = styled.a`
  cursor: pointer;

  ${({ type }) => {
    switch (type) {
      case "danger":
        return css`
          color: ${Colors.red200};

          &:hover {
            color: ${Colors.red300};
          }
        `;
      case "light":
        return css`
          color: ${Colors.white};

          &:hover {
            color: ${Colors.white};
          }
        `;
      case "embed":
        return css`
          color: #${queryStringParams().embed_primary_color};

          &:hover {
            color: #${queryStringParams().embed_primary_highlight_color};
          }
        `;
    }
  }}
`;

export default Link;
